<template>

  <body class="dx-viewport">
    <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsTarget" :allowColumnResizing="true"
      :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
      :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="true"
      @selection-changed="onSelectionChanged" @row-removing="onRowRemoving">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="5" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxStateStoring :enabled="true" :filterValue="false" storage-key="Target" />
      <DxToolbar>
        <DxItem>
          <template #default>
            <DxButton icon="add" type="success" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem>
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
        <DxItem location="after">
          <template #default>
            <DxButton icon="columnchooser" @click="onColumnChooserClick" />
          </template>
        </DxItem>
      </DxToolbar>

      <DxColumnChooser :enabled="true" />

      <!-- Editare -->
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="520">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid>
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem data-field="Denumire" :col-span="2">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>
            </DxItem>
            <DxItem data-field="TargetGeneral" :isRequired="true" editorType="dxNumberBox"
              :editorOptions="{ format: '#,##0.00', precision: 2 }">
            </DxItem>

            <DxItem data-field="ValutaID" editor-type="dxSelectBox" :editor-options="{
              dataSource: valute,
              displayExpr: 'Simbol',
              valueExpr: 'Id',
              placeholder: 'Selectează valuta'
            }" :label="{ text: 'Valuta' }" />

            <DxItem data-field="DataStart" caption="Ziua de început" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">

            </DxItem>
            <DxItem data-field="DataEnd" caption="Ziua de final" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">
            </DxItem>


            <DxItem data-field="CurentActiv" />
          </DxItem>
          <DxItem dataField="Explicatie" :colSpan="2" :editor-options="{ height: 100 }" />
        </DxFormGrid>
      </DxEditing>


      <DxColumn data-field="Denumire" />
      <DxColumn data-field="DataStart" caption="Ziua de început" />
      <DxColumn data-field="DataEnd" caption=" Ziua de final" />
      <DxColumn data-field="TargetGeneral" caption="Target General" format="#,##0.00" />
      <DxColumn data-field="ValutaID" caption="Valuta">
        <DxLookup :data-source="valute" display-expr="Simbol" value-expr="Id" />
      </DxColumn>
      <DxColumn data-field="CurentActiv" />
      <DxColumn data-field="Explicatie" caption="Explicație" />


    </DxDataGrid>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="600" :height="520">
      <template #title>
        <div
          style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
          Adăugare
        </div>
      </template>
      <div>
        <DxForm :formData="formData">
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem dataField="Denumire" :col-span="2" :col-count="2" :isRequired="true">
              <DxValidationRule>
                <DxRequiredRule />
              </DxValidationRule>

            </DxItem>
            <DxItem dataField="TargetGeneral" :label="{ text: 'Target General' }" :isRequired="true"
              editorType="dxNumberBox" :editorOptions="{ format: '#,##0.00', precision: 2 }" />

            <DxItem data-field="ValutaID" editor-type="dxSelectBox" :editor-options="{
              dataSource: valute,
              displayExpr: 'Simbol',
              valueExpr: 'Id',
              placeholder: 'Selectează valuta'
            }" :label="{ text: 'Valuta' }" />

            <DxItem data-field="DataStart" :label="{ text: 'Ziua de început' }" :isRequired="true"
              editorType="dxDateBox"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">

            </DxItem>
            <DxItem data-field="DataEnd" :label="{ text: 'Ziua de final' }" :isRequired="true" editorType="dxDateBox"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }">
            </DxItem>

            <DxItem dataField="CurentActiv" editorType="dxCheckBox" :editor-options="{ width: 250 }" />

          </DxItem>
          <DxItem dataField="Explicatie" :editor-options="{ height: 100 }" :colSpan="2" />

        </DxForm>
        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 30px;">
          <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
          <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
        </div>
      </div>
    </DxPopupAdd>
  </body>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxColumnChooser,
  DxLookup,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import CrmTarget from '@/services/Comercial/CrmTarget';
import GridIndustrii from './GridIndustrii.vue';
import http from "@/settings/apiSettings";

export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxColumnChooser,
    DxLookup,
  },

  data() {
    return {
      dsTarget: {} as ODataStore,
      isModalVisible: false,
      formData: {
        Denumire: '',
        Explicatie: '',
        DataStart: null,
        DataEnd: null,
        TargetGeneral: 0,
        CurentActiv: false,
        ValutaID: null,
      },
      valute: [] as any[],
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",

      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
          <div style="background-color: #ff2c21; font-size: 15px; float: right; height:47px; width:665px; color: white; 
          font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
      },
    };
  },
  methods: {
    async getValute() {
      try {
        const response = await http.clientComercialOdata.get('/ERP_Valute?$select=Id,Simbol');
        this.valute = response.data.value;
        console.log("Valute incarcate in GridTarget:", this.valute);
      } catch (e) {
        console.error("Error fetching valute:", e);
      }
    },

    createODataContext() {
      this.dsTarget = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_Target',
        key: 'ID',
        version: 4,
        fieldTypes: {
          ID: 'Guid',
          ValutaID: 'Guid'
        },
        beforeSend: (e) => {
          e.headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
          };
        },
      });
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    onSaveAdd() {
      if (!this.formData.Denumire || this.formData.Denumire.trim() === '') {
        notify('Completați câmpul obligatoriu "Denumire"!', 'error', 1000);
        return;
      }

      if (!this.formData.DataStart || this.formData.DataStart === null) {
        notify('Completați câmpul obligatoriu "Ziua de început"!', 'error', 1000);
        return;
      }
      if (!this.formData.DataEnd || this.formData.DataEnd === null) {
        notify('Completați câmpul obligatoriu "Ziua de final"!', 'error', 1000);
        return;
      }
      if (!this.formData.TargetGeneral) {
        notify('Completați câmpul obligatoriu "TargetGeneral"!', 'error', 1000);
        return;
      }
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      console.log(this.formData);
      const body = this.formData;
      CrmTarget.save(body).then((response) => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.dataGridRef?.instance?.refresh();
        this.formData = {
          Denumire: '',
          Explicatie: '',
          DataStart: null,
          DataEnd: null,
          TargetGeneral: 0,
          CurentActiv: false,
          ValutaID: null,
        };
      }).catch((error) => {
        console.error(error);
        notify('Datele există deja!', 'error', 1000);
      });
    },
    onSelectionChanged(e) {
      const selectedRowData = e.selectedRowsData[0];

      if (selectedRowData) {
        this.$emit('selectionChanged', selectedRowData);
      }
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = (this.$refs.dataGridRef as any).instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSaveEdit() {
      const savePromise = this.dataGridRef?.instance?.saveEditData();
      if (savePromise) {
        savePromise.then(() => {
          notify('Datele au fost actualizate cu succes!', 'success', 1000);
          this.dataGridRef?.instance?.refresh();
        }).catch((error) => {
          console.error(error);
        });
      }
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise((resolve) => {
        this.dataGridRef?.instance?.saveEditData();
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
  },
  mounted() {
    this.getValute();
    this.createODataContext();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped>
.border {
  border-radius: 8px;
}
</style>